<template>
  <div>
    <router-link :to="{ name: 'talent.profile.show', params: { id: responded.id } }">
      <div class="details">
        <div class="details">
          <h2 class="h5">{{ responded.name }}</h2>
        </div>
      </div>
    </router-link>
    <p class="text-black-50">Responded: <br/>{{ responded.created_at | timeTimezone($user.timezone) }} on {{ responded.created_at | dateTimezone($user.timezone, $user.date_format_preference) }}</p>
  </div>
</template>

<script>
export default {
  props: ['responded', 'index']
}
</script>

<style lang="scss" scoped>
.h5 {
  font-weight: bold;
}
</style>
